import * as http from 'utils/http';
import config from 'config';

export const fetchMessages = async (conversationId) =>
  http.get(`${config.API_URL}ticketing/conversations/${conversationId}/messages/`);

export const fetchConversationStatus = async (conversationId) => {
  const res = await http.get(`${config.API_URL}ticketing/conversations/${conversationId}/`);
  return res?.status;
};

export const addMessage = async (conversationId, message) =>
  http.put(`${config.API_URL}ticketing/conversations/${conversationId}/messages/`, {
    message: message,
  });

export const createConversation = async (journeyId) =>
  http.post(`${config.API_URL}ticketing/conversations/`, {
    subject: `J${journeyId}`,
    journey_id: journeyId,
  });

export const getDownloadImageBlob = async (url) => http.rawGet(url, null, null, true);
